import Menu from "../../../components/Menu"

import styles from "./Vyroba.module.sass"


const App = ({ className }) => {



  return (
    <div className={styles.overlay}>
      <Menu typ="vyroba" />
    </div>
  );
};
export default App;
